import { render } from "./CondicionesPresupuestosPage.vue?vue&type=template&id=518235f6"
import script from "./CondicionesPresupuestosPage.vue?vue&type=script&lang=js"
export * from "./CondicionesPresupuestosPage.vue?vue&type=script&lang=js"

import "./CondicionesPresupuestosPage.vue?vue&type=style&index=0&id=518235f6&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__